import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import Modal from "react-modal";
import { toast } from "react-toastify";
import moment from "moment";

const SqcForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "430px",

      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const [loading, setLoading] = useState(false);

  const frmRef = useRef({});
  const { sendRequest: getEmp } = useHttp();
  const [employeeId, setEmployeeId] = useState();
  const [isChecklistOpen, setIsChecklistOpen] = useState(false);
  const checkListRef = useRef({});
  const [checkListDetails, setCheckListDetails] = useState([]);

  const observationRef = useRef({});
  const [ObservationDetails, setObservationDetails] = useState([]);
  const [isObservationOpen, setIsObservationOpen] = useState(false);

  const [seedProducts, setSeedProducts] = useState([]);
  const [selectedResult, setSelectedResult] = useState("");

  const [uploadedFiles, setUploadedFiles] = useState([]);

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  const [lotData, setlotData] = useState([]);

  const { sendRequest: getLot } = useHttp();

  useEffect(() => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      process: "SQC",
    };
    getLot(
      {
        url: "/api/getStockLotForPackhouseProcess/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);

        setlotData(data);
      }
    );
  }, [getLot]);

  const { sendRequest: getObservation } = useHttp();
  const { sendRequest: getSeedProducts } = useHttp();

  const handleLotIdChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;
    const data = lotData && lotData.filter((item) => item.stockId == id);
    frmRef.current.product_name.value = data[0] && data[0].productName;
    frmRef.current.avl_qty.value =
      data[0] &&
      data[0].productQuantityBal + " " + data[0].productunitAbbreviation;
    frmRef.current.crop_name.value = data[0] && data[0].productSubTypeName;
    frmRef.current.variety.value = data[0] && data[0].productTypeName;

    //console.log("data", data);

    const varietyId = data[0] && data[0].varietyId;
    getObservation(
      {
        url: `/api/varietywiseSeedQualityParamter/?orgId=${localStorage.getItem(
          "orgId"
        )}&varietyId=${varietyId}`,
      },
      (data) => {
        //console.log(data);
        setObservationDetails(data);
      }
    );

    getSeedProducts(
      {
        url: `/api/getSeedProduct/?orgId=${localStorage.getItem(
          "orgId"
        )}&varietyId=${varietyId}`,
      },
      (data) => {
        //console.log(data);
        setSeedProducts(data.seedProductList);
      }
    );
  };

  useEffect(() => {
    frmRef.current.seed_product_name.value = "";
  }, [selectedResult]);

  const submitCheckList = (e) => {
    e.preventDefault();
    setCheckListDetails([
      {
        contamination: checkListRef.current.contamination.value,
        uniformSize: checkListRef.current.uniform_size.value,
        fungicideDetection: checkListRef.current.fungicide_detection.value,
        FreefromSDD: checkListRef.current.sdd.value,
        FreefromLTSF: checkListRef.current.ltsf.value,
      },
    ]);

    setIsChecklistOpen(false);
    //console.log(checkListDetails);
  };

  const handleObservationChange = (e, index) => {
    const newValue = e.target.value;

    // setObservationDetails(
    //   ObservationDetails &&
    //     ObservationDetails.map((x) => ({
    //       ...x,
    //       seedObservationId: parseInt(x.observationId),
    //     }))
    // );

    setObservationDetails((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].observation = newValue;
      return updatedDetails;
    });
  };

  const handleRemarkChange = (e, index) => {
    const newValue = e.target.value;

    setObservationDetails((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].remark = newValue;
      //console.log(updatedDetails);
      return updatedDetails;
    });
  };

    const attachmentFolder=localStorage.getItem("attachmentFolder");

  const handleAttachmentChange = (e) => {
    const files = e.target.files;

    const picDataArray = Array.from(files).map((file) => {
      const uniqueFilename = `${new Date().valueOf()}/${file.name}`;
      const picData = new FormData();
      picData.append("fileUpload", file, uniqueFilename);
      return picData;
    });

    const uploadedFilesData = [];

    Promise.all(
      picDataArray.map((picData) =>
        fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/file/${attachmentFolder}/sqcattachment/${new Date().valueOf()}}`,
          {
            method: "POST",
            body: picData,
          }
        )
          .then((res) => res.json())
          .then((data) => {
            uploadedFilesData.push(data.url);
          })
      )
    )
      .then(() => {
        setUploadedFiles([...uploadedFiles, ...uploadedFilesData]);
      })
      .catch((err) => console.error(err));
  };

  const { sendRequest: postSqc } = useHttp();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (ObservationDetails && ObservationDetails.length === 0) {
      toast.error("Observation Paramter required");
      return;
    }
    if (checkListDetails == "") {
      toast.error("Check list data required");
      return;
    }
    setLoading(true);

    const data = {
      seedQCDate: moment(frmRef.current.sqc_date.value).format("DD/MM/YYYY"),
      timeStamp: frmRef.current.inspection_time.value,
      supervisorEmployeeId: frmRef.current.inspected_by.value,
      stockId: frmRef.current.lot_id.value,
      temperature: frmRef.current.temp.value,
      seedProductId: frmRef.current.seed_product_name.value,
      result: frmRef.current.result.value,
      attachmentUrl: uploadedFiles,
      paramterDetail: ObservationDetails,
      checkList: checkListDetails,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    //console.log(data);
    postSqc(
      {
        url: "/api/seedQualityCheck/",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`Seed Quality Check done successfully`);
        setLoading(false);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  return (
    <>
      {isChecklistOpen && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Check List Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsChecklistOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <form onSubmit={submitCheckList}>
            <div className="row mb-2">
              <div className="col-md-4">
                <label htmlFor="contamination">Contamination</label>

                <select
                  id="contamination"
                  name="contamination"
                  ref={(el) => (checkListRef.current["contamination"] = el)}
                  className="form-control"
                  required
                >
                  {" "}
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="col-md-4">
                <label htmlFor="uniform_size">Uniform Size</label>

                <select
                  id="uniform_size"
                  name="uniform_size"
                  ref={(el) => (checkListRef.current["uniform_size"] = el)}
                  className="form-control"
                  required
                >
                  {" "}
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="col-md-4">
                <label htmlFor="fungicide_detection">Fungicide Detection</label>

                <select
                  id="fungicide_detection"
                  name="fungicide_detection"
                  ref={(el) =>
                    (checkListRef.current["fungicide_detection"] = el)
                  }
                  className="form-control"
                  required
                >
                  {" "}
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-4">
                <label htmlFor="contamination">
                  Free from stones,debris and dust
                </label>

                <select
                  id="contamination"
                  name="contamination"
                  ref={(el) => (checkListRef.current["sdd"] = el)}
                  className="form-control"
                  required
                >
                  {" "}
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="col-md-4">
                <label htmlFor="contamination">
                  Free from leafs,twigs, stems,flowers
                </label>

                <select
                  id="contamination"
                  name="contamination"
                  ref={(el) => (checkListRef.current["ltsf"] = el)}
                  className="form-control"
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            <br />
            <div className="text-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </Modal>
      )}

      {isObservationOpen && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Observation Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsObservationOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <form>
            <div>
              <table className="table table-bordered table-sm text-center">
                <thead>
                  <tr className="">
                    <th>Sr No</th>
                    <th>Paramter Name</th>
                    <th>Stdndard Observation</th>
                    <th>Observation</th>
                    <th>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {ObservationDetails &&
                    ObservationDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.parameterName}</td>
                          <td>{itm.standardObservation}</td>

                          <td>
                            <input
                              type="text"
                              id={`Observation-${i}`}
                              required
                              ref={(el) =>
                                (frmRef.current[`observation-${i}`] = el)
                              }
                              className="form-control"
                              value={itm.observation || ""}
                              onChange={(e) => handleObservationChange(e, i)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={`remark-${i}`}
                              required
                              ref={(el) => (frmRef.current[`remark-${i}`] = el)}
                              className="form-control"
                              value={itm.remark || ""}
                              onChange={(e) => handleRemarkChange(e, i)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <br />
            <div className="text-center">
              <button
                type="submit"
                className="btn btn-sm btn-primary"
                onClick={() => setIsObservationOpen(false)}
              >
                Save
              </button>
            </div>
          </form>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={handleSubmit}>
                <div className="card-header">
                  <h3 className="card-title">Seed Quality Check Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"dpi_date"}> {"Seed Qc Date"}</label>
                      <input
                        type={"date"}
                        id={"sqc_date"}
                        required
                        ref={(el) => (frmRef.current["sqc_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspection_time"}>
                        {" "}
                        {"Inspection Time "}
                      </label>
                      <input
                        type={"time"}
                        id={"inspection_time"}
                        required
                        ref={(el) => (frmRef.current["inspection_time"] = el)}
                        defaultValue={getCurrentTime()}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspected_by"}>{"Inspected By"}</label>
                      <select
                        id="inspected_by"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["inspected_by"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              key={x.empId}
                              selected={
                                props.update &&
                                props.update.supervisorEmployeeId == x.empId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"lot_id"}> {"Lot id "}</label>
                      <select
                        id="lot_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        required
                        onChange={handleLotIdChange}
                      >
                        <option value="">Select</option>
                        {lotData &&
                          lotData.map((x) => (
                            <option value={x.stockId}>{x.lotNo}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Product Name"}> {"Product Name"}</label>
                      <input
                        type={"text"}
                        id={"product_name"}
                        required
                        ref={(el) => (frmRef.current["product_name"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"avl_qty"}> {"Available Quantity"}</label>
                      <input
                        type={"text"}
                        id={"avl_qty"}
                        min="0"
                        required
                        ref={(el) => (frmRef.current["avl_qty"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"crop_name"}> {"Crop Name"}</label>
                      <input
                        type={"text"}
                        id={"crop_name"}
                        required
                        ref={(el) => (frmRef.current["crop_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Product Name"}> {"Variety"}</label>
                      <input
                        type={"text"}
                        id={"variety"}
                        required
                        ref={(el) => (frmRef.current["variety"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"shelf_life"}>{"Temperature(°C)"}</label>
                      <input
                        type={"number"}
                        id={"temp"}
                        required
                        ref={(el) => (frmRef.current["temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"result"}>{"Result"}</label>
                      <select
                        id="result"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["result"] = el)}
                        required
                        onChange={(e) => setSelectedResult(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="pass">Pass</option>
                        <option value="fail">Fail</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"seed_product_name"}>
                        {"Seed Product Name"}
                      </label>
                      <select
                        id="seed_product_name"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["seed_product_name"] = el)}
                        required
                        disabled={selectedResult == "pass" ? false : true}
                      >
                        <option value="">Select</option>
                        {seedProducts &&
                          seedProducts.map((x) => (
                            <option value={x.productId} key={x.productId}>
                              {x.productName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sample_check"}> {"Check List"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"sample_check"}
                        ref={(el) => (frmRef.current["sample_check"] = el)}
                        className="btn btn-sm btn-warning"
                        autoComplete="off"
                        onClick={() => {
                          setIsChecklistOpen(true);
                        }}
                      >
                        Check
                      </button>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"observation_paramter"}>
                        {" "}
                        {"Observation Paramter"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"observation_paramter"}
                        autoComplete="off"
                        ref={(el) =>
                          (frmRef.current["observation_paramter"] = el)
                        }
                        className="btn btn-sm btn-info"
                        onClick={() => {
                          setIsObservationOpen(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Attachment"}>{"Attachment"}</label>
                      <label className="custom-file-upload">
                        <input
                          type="file"
                          id={"attachment"}
                          ref={(el) => (frmRef.current["attachment"] = el)}
                          className="form-control"
                          multiple // Allow multiple file selection
                          onChange={handleAttachmentChange}
                        />
                      </label>
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SqcForm;
